import ONLINE_ICON from "assets/icons/online.svg";
import OFFLINE_ICON from "assets/icons/offline.svg";
import WARNING_RED_ICON from "assets/icons/warning_red.svg";
import WARNING_ICON from "assets/icons/warning.svg";
import ASSGINED_WARNING from "assets/icons/assigned_warning.svg";
import CRITICAL_WARNING from "assets/icons/critical_warning.svg";
import UNKNOWN_WARNING from "assets/icons/triangle_warning_red.svg";
import styled from "styled-components";
import { FLEX } from "styles/flex";
import { useMemo } from "react";

interface StatusProps {
  status?: string;
}

function Status({ status }: StatusProps): JSX.Element {
  const imgSrc = useMemo(() => {
    switch (status) {
      case "online":
        return ONLINE_ICON;
      case "healthy":
        return ONLINE_ICON;
      case "offline":
        return OFFLINE_ICON;
      case "detected":
        return WARNING_RED_ICON;
      case "alert":
        return WARNING_RED_ICON;
      case "warning":
        return WARNING_ICON;
      case "assigned":
        return ASSGINED_WARNING;
      case "critical":
        return CRITICAL_WARNING;
      case "unknown":
        return UNKNOWN_WARNING;
      default:
        return ONLINE_ICON;
    }
  }, [status]);
  return (
    <Icon>
      <img src={imgSrc} alt="status icon" />
    </Icon>
  );
}

const Icon = styled.div`
  width: 16px;
  ${FLEX.FlexStartCenter};

  img {
    width: 100%;
  }
`;
export default Status;
